<!-- Menu.svelte -->
<script>
  import MenuItems from './MenuItems2.svelte';
  import MenuItemsSelect from './MenuItemsSelect.svelte';
  import { createEventDispatcher, onMount } from "svelte";
  const dispatch = createEventDispatcher();
  export let menuItems;
  export let categories;
  export let menuLevel = 0;
  export let originalMenuItems;

  onMount(()=>{

    

  });

 
  // Function to toggle the visibility of children
  function toggleChildren(item) {

    item.showChildren = !item.showChildren;

    // if (item.children && item.children.length > 0 && item.showChildren) {

    //   console.log(item.showChildren,item.children.length)

    // }
  }



  function openCategoryBox(event) {

    dispatch('openCategoryBox',event.detail)

  }

  function setConnectedCat(cat,selectedItem) {


    // if (!selectedItem.categories_connections.some(item => item.id === cat.id)) {
    //   selectedItem.categories_connections.push(cat); // Add the full `cat` object
    // } else {
      const index = selectedItem.categories_connections.findIndex(item => item.id === cat.id);
      if (index !== -1) {
          selectedItem.categories_connections.splice(index, 1); // Remove the item at the found index
      }
    //}
    selectedItem.categories_connections = selectedItem.categories_connections;
    menuItems = menuItems;


    // if (!item.connected_categories.includes(cat)) {
    //   item.connected_categories.push(cat)
    // } else {
    //   item.connected_categories = item.connected_categories.filter(name => name !== cat);
    // }
    // item.connected_categories = item.connected_categories;

    // menuItems = menuItems;


  }

</script>

<ul>
  {#each menuItems as item (item.id)}
    <li>
      <div on:click={() => toggleChildren(item)} class:emptycat={!item.categories_connections?.length}>
        <div class="row">
          {item.firstname} {item.lastname} {item.company}
          <input type="text" bind:value="{item.name}">
          
          אחוז <input type="text" bind:value="{item.discount}" class="w-[100px]">
          
          <button class="open_popup_button" on:click={ ()=> dispatch('openCategoryBox',item) }>בחירת קטגוריות</button>
        </div>
        <div class="connected_categories">
          
            {#each item.categories_connections as cat}
              {#if cat.id !==null} 
              <span><span on:click={ () => setConnectedCat(cat,item)}>x</span>{cat.name}</span>
              {/if}
            {/each}
          
        </div>
      </div>
      {#if item.children && item.children.length > 0}
      <MenuItems originalMenuItems={originalMenuItems} menuItems={item.children} {categories} {menuLevel} on:openCategoryBox={openCategoryBox}/>
      {/if}
    </li>
  {/each}
</ul>

<style>
  .emptycat {
    background-color: pink;
  }
  .row {
    padding:5px 0;
  }
  .open_popup_button {
    background-color: #011f53;
    border: 0;
    color: #fff;
    padding: 2px 15px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 12px;
  }
  .connected_categories > span{
    padding: 2px;
    background-color: rgb(205, 216, 255);
    border-radius: 2px;
    /* color: #fff; */
    font-size: 12px;
    padding: 5px;
    margin: 3px;
    display: inline-block;
    cursor:default;
  }
  .connected_categories > span > span{
    border-radius: 50%;
    background-color: #6c79a7;
    width: 18px;
    display: inline-block;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
  ul {
    list-style: none;
    padding-left: 0;
    padding-right:10px;
  }

  li {
    margin-bottom: 5px;
  }

  span {
    cursor: pointer;
  }
  input {
    width:auto;
  }
</style>
